import React, { Component } from "react"
import { Dialog } from "@tencent/spaui"
import { withAccount } from "@/business-components/operator/account-context"
import cookie from "@/utils/cookie"
import { parseUrl } from "query-string"
import "./debug-info.scoped.less"

@withAccount
class DebugInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
    }
    this.debug = location.search.indexOf("__debug__") !== -1 || cookie.get("__debug__")

    if (this.debug) {
      window.__debug__ = props.account
    }
    const { query = {} } = parseUrl(location.href)
    this.debugCall = query.debugCall === "1"
  }

  componentDidMount() {
    if (this.debugCall) {
      this.askUserMedia()
    }
  }

  handleClose = () => {
    this.setState({ show: false })
  }

  handleShow = () => {
    this.setState({ show: true })
  }

  /**
   * @description: 读取媒体权限
   */
  getUserMedia = async () => {
    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {}
    }
    if (navigator.mediaDevices.getUserMedia === undefined) {
      navigator.mediaDevices.getUserMedia = function (constraints) {
        var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia
        if (!getUserMedia) {
          return Promise.reject(new Error("getUserMedia is not implemented in this browser"))
        }
        return new Promise(function (resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject)
        })
      }
    }
    return await navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(function (stream) {
        return { info: { active: stream.active, id: stream.id }, msg: "麦克风权限开启成功" }
      })
      .catch(function (err) {
        return { info: { name: err.name, message: err.message }, msg: "麦克风权限开启失败" }
      })
  }

  askUserMedia = async () => {
    const userMediaInfo = await this.getUserMedia()
    this.setState({ userMediaInfo })
  }

  renderUserMedia = () => {
    const { userMediaInfo = {} } = this.state
    const { info = {}, msg = "" } = userMediaInfo
    return (
      <ul className={"agency-debug-info-list"}>
        <li>
          info：<pre>{JSON.stringify(info, null, 2)}</pre>
        </li>
        <li>msg: {msg}</li>
      </ul>
    )
  }

  renderAccountInfo = () => {
    const { account } = this.props
    return (
      <ul className={"agency-debug-info-list"}>
        <li>当前环境：{account.env}</li>
        <li>release: {process.env.REACT_APP_NAME + "@" + process.env.REACT_APP_VERSION}</li>
        <li>user_id: {account.user_id}</li>
        <li>bm_id: {account.bm_id || "-"}</li>
        <li>agency_uid: {account.agency_uid || "-"}</li>
        <li>
          feature_flag: <pre>{JSON.stringify(account.feature_flag, null, 2)}</pre>
        </li>
        {/*<li>*/}
        {/*  privilege: <pre>{JSON.stringify(account.privilege, null, 2)}</pre>*/}
        {/*</li>*/}
      </ul>
    )
  }

  render() {
    if (this.debug || this.debugCall) {
      const { show } = this.state
      return (
        <div className={"agency-debug-info"}>
          <i onClick={this.handleShow} className="agency-debug-btn spaui-menu-icon icon-manage"></i>

          <Dialog show={show} hideScrollBar={false} onClose={this.handleClose} onSubmit={this.handleClose} onCancel={this.handleClose} title="信息提示">
            {this.debug ? this.renderAccountInfo() : null}
            {this.debugCall && this.renderUserMedia()}
          </Dialog>
        </div>
      )
    }
    return null
  }
}

export default DebugInfo
